import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import { ref, onValue, get } from "firebase/database";
import { getMessaging, getToken } from "firebase/messaging";
import { useParams } from "react-router-dom";

export default function NotificationSender() {
  const { userId } = useParams();
  const [distributors, setDistributors] = useState([]);
  const [selectedDistributors, setSelectedDistributors] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [notificationType, setNotificationType] = useState("general");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [linkUrl, setLinkUrl] = useState("");

  useEffect(() => {
    loadDistributors();
  }, []);

  useEffect(() => {
  if (userId) {
    setSelectedDistributors([userId]);
  }
}, [userId]);

  const loadDistributors = () => {
    const usersRef = ref(db, "users");
    onValue(usersRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const distributorsList = Object.keys(data)
        .filter(key => 
  data[key].userType === "professional" || 
  data[key].userType === "admin"
)
          .map(key => ({
            id: key,
            ...data[key],
            fcmToken: data[key].fcmToken || null
          }));
        setDistributors(distributorsList);
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedDistributors([]);
    } else {
      setSelectedDistributors(distributors.map(d => d.id));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectDistributor = (distributorId) => {
    if (selectedDistributors.includes(distributorId)) {
      setSelectedDistributors(selectedDistributors.filter(id => id !== distributorId));
    } else {
      setSelectedDistributors([...selectedDistributors, distributorId]);
    }
  };

  const sendNotification = async () => {
    if (!title.trim()) {
      alert("الرجاء إدخال عنوان الإشعار");
      return;
    }
    if (!message.trim()) {
      alert("الرجاء إدخال نص الإشعار");
      return;
    }
    if (selectedDistributors.length === 0) {
      alert("الرجاء اختيار موزع واحد على الأقل");
      return;
    }

    setSending(true);
    setResult(null);

    try {
      // استدعاء Cloud Function
      const response = await fetch("https://us-central1-bizcontrol-478cd.cloudfunctions.net/sendNotification", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          distributorIds: selectedDistributors,
          notification: {
            title: title,
            body: message,
            type: notificationType,
            imageUrl: imageUrl || null,
            linkUrl: linkUrl || null,
            timestamp: Date.now()
          }
        })
      });

      const result = await response.json();
      
      if (result.success) {
        setResult({
          success: true,
          message: `تم إرسال الإشعار بنجاح إلى ${result.sentCount} موزع`
        });
        // مسح الحقول
        setTitle("");
        setMessage("");
        setImageUrl("");
        setLinkUrl("");
        setSelectedDistributors([]);
        setSelectAll(false);
      } else {
        setResult({
          success: false,
          message: result.error || "فشل إرسال الإشعار"
        });
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      setResult({
        success: false,
        message: `خطأ: ${error.message}`
      });
    } finally {
      setSending(false);
    }
  };

  const sendTestNotification = async () => {
    if (selectedDistributors.length === 0) {
      alert("الرجاء اختيار موزع لاختبار الإشعار");
      return;
    }

    setSending(true);
    try {
      const response = await fetch("https://your-region-your-project.cloudfunctions.net/sendTestNotification", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          distributorId: selectedDistributors[0],
          testMessage: "هذا إشعار تجريبي من لوحة التحكم"
        })
      });

      const result = await response.json();
      if (result.success) {
        alert("✅ تم إرسال الإشعار التجريبي بنجاح");
      } else {
        alert("❌ فشل إرسال الإشعار التجريبي");
      }
    } catch (error) {
      alert(`خطأ: ${error.message}`);
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ padding: 20, maxWidth: 800, margin: "0 auto" }}>
      <h2>📨 إرسال إشعارات للموزعين</h2>

      {/* نتائج الإرسال */}
      {result && (
        <div style={{
          padding: 15,
          marginBottom: 20,
          background: result.success ? "#d4edda" : "#f8d7da",
          color: result.success ? "#155724" : "#721c24",
          borderRadius: 8,
          border: `1px solid ${result.success ? "#c3e6cb" : "#f5c6cb"}`
        }}>
          {result.message}
        </div>
      )}

      {/* نموذج الإشعار */}
      <div style={{ background: "#f8fafc", padding: 20, borderRadius: 8, marginBottom: 20 }}>
        <h3>تفاصيل الإشعار</h3>
        
        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold" }}>
            عنوان الإشعار *
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="مثال: عرض خاص"
            style={{ width: "100%", padding: 10, borderRadius: 4, border: "1px solid #ccc" }}
          />
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold" }}>
            نص الإشعار *
          </label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="نص الإشعار..."
            rows="4"
            style={{ width: "100%", padding: 10, borderRadius: 4, border: "1px solid #ccc" }}
          />
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold" }}>
            نوع الإشعار
          </label>
          <select
            value={notificationType}
            onChange={(e) => setNotificationType(e.target.value)}
            style={{ width: "100%", padding: 10, borderRadius: 4, border: "1px solid #ccc" }}
          >
            <option value="general">عام</option>
            <option value="promotion">عرض ترويجي</option>
            <option value="important">هام</option>
            <option value="update">تحديث</option>
          </select>
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold" }}>
            رابط الصورة (اختياري)
          </label>
          <input
            type="text"
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
            placeholder="https://example.com/image.jpg"
            style={{ width: "100%", padding: 10, borderRadius: 4, border: "1px solid #ccc" }}
          />
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "block", marginBottom: 5, fontWeight: "bold" }}>
            رابط التشغيل (اختياري)
          </label>
          <input
            type="text"
            value={linkUrl}
            onChange={(e) => setLinkUrl(e.target.value)}
            placeholder="https://example.com/page"
            style={{ width: "100%", padding: 10, borderRadius: 4, border: "1px solid #ccc" }}
          />
        </div>
      </div>

      {/* اختيار الموزعين */}
      <div style={{ background: "#f8fafc", padding: 20, borderRadius: 8, marginBottom: 20 }}>
        <h3>اختيار الموزعين</h3>
        
        <div style={{ marginBottom: 15 }}>
          <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAll}
              style={{ marginRight: 10 }}
            />
            <strong>اختيار الكل ({distributors.length})</strong>
          </label>
        </div>

        <div style={{ maxHeight: 300, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 4 }}>
          {distributors.map(distributor => (
            <label
              key={distributor.id}
              style={{
                display: "flex",
                alignItems: "center",
                padding: 10,
                borderBottom: "1px solid #e2e8f0",
                cursor: "pointer",
                background: selectedDistributors.includes(distributor.id) ? "#e0e7ff" : "white"
              }}
            >
              <input
                type="checkbox"
                checked={selectedDistributors.includes(distributor.id)}
                onChange={() => handleSelectDistributor(distributor.id)}
                style={{ marginRight: 10 }}
              />
              <div>
                <strong>{distributor.tradeName || distributor.email || distributor.id}</strong>
                <div style={{ fontSize: 12, color: "#666" }}>
                  {distributor.fcmToken ? "✅ مسجل للإشعارات" : "❌ غير مسجل للإشعارات"}
                </div>
              </div>
            </label>
          ))}
        </div>
      </div>

      {/* أزرار الإرسال */}
      <div style={{ display: "flex", gap: 15, justifyContent: "center" }}>
        <button
          onClick={sendNotification}
          disabled={sending || selectedDistributors.length === 0}
          style={{
            padding: "12px 24px",
            background: sending ? "#9ca3af" : "#3b82f6",
            color: "white",
            border: "none",
            borderRadius: 8,
            fontSize: "16px",
            cursor: sending ? "not-allowed" : "pointer",
            minWidth: 200
          }}
        >
          {sending ? "جاري الإرسال..." : "📤 إرسال الإشعار"}
        </button>
        
        <button
          onClick={sendTestNotification}
          disabled={sending || selectedDistributors.length === 0}
          style={{
            padding: "12px 24px",
            background: sending ? "#9ca3af" : "#10b981",
            color: "white",
            border: "none",
            borderRadius: 8,
            fontSize: "16px",
            cursor: sending ? "not-allowed" : "pointer",
            minWidth: 200
          }}
        >
          🔔 إرسال تجريبي
        </button>
      </div>

      {/* إحصائيات */}
      <div style={{ marginTop: 30, padding: 15, background: "#f0f9ff", borderRadius: 8 }}>
        <h4>📊 إحصائيات</h4>
        <div>إجمالي الموزعين: {distributors.length}</div>
        <div>الموزعين المختارين: {selectedDistributors.length}</div>
        <div>الموزعين المسجلين للإشعارات: {distributors.filter(d => d.fcmToken).length}</div>
      </div>
    </div>
  );
}